export default __webpack_public_path__ + "static/media/img_company_header2.f7d45914.png";